import { IUserProfile, IVersion } from '@/interfaces';
import { MainState, AppNotification } from './state';
import { IConfig } from '@/interfaces/config';

export const mutations = {
  setToken(state: MainState, payload: string) {
    state.token = payload;
  },
  setLoggedIn(state: MainState, payload: boolean) {
    state.isLoggedIn = payload;
  },
  setLogInError(state: MainState, payload: boolean) {
    state.logInError = payload;
  },
  setUserProfile(state: MainState, payload: IUserProfile) {
    state.userProfile = payload;
  },
  setDashboardMiniDrawer(state: MainState, payload: boolean) {
    state.dashboardMiniDrawer = payload;
  },
  setDashboardShowDrawer(state: MainState, payload: boolean) {
    state.dashboardShowDrawer = payload;
  },
  addNotification(state: MainState, payload: AppNotification) {
    state.notifications.push(payload);
  },
  setNotifications(state: MainState, payload: AppNotification[]) {
    state.notifications = payload;
  },
  setLang(state: MainState, payload: string) {
    state.lang = payload;
  },
  setShowProgress(state: MainState, payload: boolean) {
    state.showProgress = payload;
  },
  removeNotification(state: MainState, payload: AppNotification) {
    state.notifications = state.notifications.filter((notification) => notification !== payload);
  },
  setVersion(state: MainState, payload: IVersion) {
    if (!payload) return;

    const formatBuildTime = (isoDate: string) => {
      const dateObj = new Date(isoDate);
      if (!dateObj) return '';

      const year = dateObj.getFullYear();
      const month = String(dateObj.getMonth() + 1).padStart(2, '0');
      const day = String(dateObj.getDate()).padStart(2, '0');
      const hours = String(dateObj.getHours()).padStart(2, '0');
      const minutes = String(dateObj.getMinutes()).padStart(2, '0');
      const seconds = String(dateObj.getSeconds()).padStart(2, '0');
      const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      return formattedDate;
    };

    state.version = {
      ...payload,
      buildTime: formatBuildTime(payload.buildTime),
    };
  },
  setConfig(state: MainState, payload: IConfig) {
    state.config = payload;
  },
};
